import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CustomSelect from '../Utilities/CustomSelect'
import { AddEmployeeAccountVM } from '../../Structure/ViewModels/Admin/AddEmployeeAccountVM'

const AddEmployeeAccount = () => {
    const [vm , setVm] = useState<{viewModel:AddEmployeeAccountVM}>({viewModel:new AddEmployeeAccountVM()})
    const control = vm.viewModel
    useEffect(()=>control.subscribeUpdate(setVm),[])
    useEffect(()=>control.getRoles(),[])


    return (
    <Container>
        {
            control.Show(
                <Row>
                    <h3 className='py-5 text-center'>انشاء حساب موظف جديد</h3>

                    <Row className='py-4 justify-content-center'>
                        <Col lg={8} className='p-3'>
                            <div className='d-flex flex-column'>
                                <Row className=' justify-content-between'>
                                    <Col md={6}>
                                        <label htmlFor="" className='my-auto p-3'>اسم الموظف</label>
                                    </Col>
                                    <Col md={6} className='d-flex flex-column'>
                                    <div className=' my-auto'>
                                        <input type="text" className='input-field my-auto w-100' autoComplete='off' value={control.data.name} onChange={a=>control.Name = a.target.value} />
                                    </div>
                                    </Col>
                                </Row> 
                                <Row className=' justify-content-between'>
                                    <Col md={6}>
                                        <label htmlFor="" className='my-auto p-4'>الوظيفة</label>
                                    </Col>
                                    <Col md={6} className='d-flex flex-column'>
                                        <div className=' my-auto'>
                                            <CustomSelect list={control.RolesList}  selected={control.data.role} onSelect={a=>control.Role = a}  ></CustomSelect>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className=' justify-content-between'>
                                    <Col md={6}>
                                        <label htmlFor="" className='my-auto p-4'>كلمة السر (اختياري)</label>
                                    </Col>
                                    <Col md={6} className='d-flex flex-column'>
                                        <div className=' my-auto'>
                                            <input type="password" className='input-field my-auto w-100' autoComplete='off' value={control.data.password} onChange={a=>control.Password = a.target.value} />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className=' justify-content-between'>
                                    <Col md={6}>
                                        <label htmlFor="" className='my-auto p-4'>تأكيد كلمة السر {control.data.password?'':'(اختياري)'}</label>
                                    </Col>
                                    <Col md={6} className='d-flex flex-column'>
                                        <div className=' my-auto'>
                                            <input type="password" className='input-field my-auto w-100' autoComplete='off' value={control.ConfPassword} onChange={a=>control.ConfPassword = a.target.value} />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <div className='d-flex justify-content-center'>
                        <button className='button-I btn-cl-I px-5 py-2 fw-bold' onClick={()=>control.send()}>اضافة</button>
                    </div>
                </Row>
            )
        }
    </Container>
  )
}

export default AddEmployeeAccount
